import React, { useState } from "react";
import LetterAnimation from "./LetterAnimation";

function SlateInput() {
  const [letter, setLetter] = useState("");
  const [speed, setSpeed] = useState("medium");

  return (
    <div className="slate-container">
      <input 
        type="text" 
        maxLength="1" 
        onChange={(e) => setLetter(e.target.value.toUpperCase())} 
        placeholder="Enter a letter" 
      />
      <select onChange={(e) => setSpeed(e.target.value)}>
        <option value="slow">Slow</option>
        <option value="medium">Medium</option>
        <option value="fast">Fast</option>
      </select>
      <LetterAnimation letter={letter} speed={speed} />
    </div>
  );
}

export default SlateInput;

